import { fromJS } from 'immutable'
import {
  CLIENT_MASTER_LIST_REQUEST,
  CLIENT_MASTER_LIST_SUCCESS,
  CLIENT_MASTER_LIST_FAILURE,
  CLIENT_MASTER_LIST_RESET,
} from '../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case CLIENT_MASTER_LIST_REQUEST:
      return state
        .set('isFetching', true)
    case CLIENT_MASTER_LIST_SUCCESS:
      return state
        .set('clients', fromJS(action.payload.clients))
        .set('isFetching', false)
    case CLIENT_MASTER_LIST_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
        .set('clients', [])
    case CLIENT_MASTER_LIST_RESET:
      return state
        .delete('clients')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/client/client-master-list-reducer.js